import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import referralCodeIcon from "../../../assets/images/ticket-discount.svg";
import userIcon from "../../../assets/images/user-2.svg";
import { GENERAL_SPECIALITY_ID } from "../../../envConstants";
import { getDecodedToken } from "../../../utils/localStorage";
import { getPediaDoctorDetails } from "../service";
import DoctorDetails from "./DoctorDetails";
import Logout from "./Logout";
import LogoutButton from "./LogoutButton";
import ProfileCard from "./ProfileCard";
import { getNativeAppVersionLabel } from "../../../utils/nativeAppUpdate";
import { getWebBuildLabel } from "../../../utils/buildInfo";

const ProfileDashboard: React.FC = () => {
  const tokenData: any = getDecodedToken();
  const doctorDetails: any = tokenData?.user || {};
  const [pediaDoctor, setPediaDoctor]: any = useState({ access_code: "" });
  const [loader, setLoader] = useState(false);
  function profilePer() {
    let result = 100;

    if (pediaDoctor?.access_code?.toString()?.startsWith("MED") || pediaDoctor?.access_code?.toString()?.startsWith("ZY")) {
      // medley doctor
      if (
        doctorDetails?.speciality !== GENERAL_SPECIALITY_ID &&
        pediaDoctor?.city_id !== null &&
        pediaDoctor?.qualification_id !== null
      ) {
        return 100;
      } else {
        return 67;
      }
    } else {
      // normal doctor
      if (doctorDetails?.speciality === GENERAL_SPECIALITY_ID) {
        return 67;
      }
    }
    return result;
  }

  const profileCards = [
    {
      icon: userIcon,
      title: "Your Profile",
      completionPercentage: profilePer(),
      bgColor: "bg-orange-400",
      navigateTo: "/profile",
    },
    // {
    //   icon: hospitalIcon,
    //   title: "Clinic Details",
    //   completionPercentage: 0,
    //   bgColor: "bg-rose-500",
    //   navigateTo: "/clinic-details",
    // },
    // {
    //   icon: idIcon,
    //   title: "KYC",
    //   completionPercentage: 0,
    //   bgColor: "bg-rose-500",
    //   navigateTo: "/kyc",
    // },
    // {
    //   icon: certificateIcon,
    //   title: "MCI Certificate",
    //   completionPercentage: 0,
    //   bgColor: "bg-rose-500",
    //   navigateTo: "/mci-certificate",
    // },
    {
      icon: referralCodeIcon,
      title: "Referral Code",
      completionPercentage: pediaDoctor?.access_code
        ?.toString()
        ?.startsWith("MED") || pediaDoctor?.access_code?.toString()?.startsWith("ZY")
        ? 100
        : 0,
      bgColor: "",
      navigateTo: pediaDoctor?.access_code?.toString()?.startsWith("MED") || pediaDoctor?.access_code?.toString()?.startsWith("ZY")
        ? `/refer?verified=true&code=${pediaDoctor?.access_code}`
        : "/refer",
    },
  ];
  const [showLogout, setShowLogout] = React.useState(false);
  const appVersionLabel = getNativeAppVersionLabel();

  const getProfileDetails = async () => {
    setLoader(true);
    const res: any = await getPediaDoctorDetails(doctorDetails?.mobileNumber);
    if (res?.status === 200) {
      setLoader(false);
      setPediaDoctor(res?.data?.body);
    }
  };

  useEffect(() => {
    getProfileDetails();
  }, []);

  return loader ? (
    <div className="flex justify-center">
      <Spin className="mt-4 flex justify-center items-center" />
    </div>
  ) : (
    <main className="flex flex-col min-h-full pt-10 bg-slate-50 w-full rounded-[42px_42px_0px_0px]">
      <DoctorDetails
        name={doctorDetails?.name}
        phoneNumber={doctorDetails?.mobileNumber}
      />
      <div className="flex-1 w-full bg-[#F9F9FF] p-[32px_16px] gap-[16px] rounded-t-[42px]">
        {profileCards.map((card, index) => (
          <ProfileCard
            key={index}
            icon={card.icon}
            title={card.title}
            completionPercentage={card.completionPercentage}
            bgColor={card.bgColor}
            navigateTo={card.navigateTo}
          />
        ))}
        <div className="flex justify-center">
          <LogoutButton onLogoutClick={() => setShowLogout(true)} />
        </div>
        <Logout show={showLogout} closePopup={() => setShowLogout(false)} />
      </div>
      {/* Release check, kept out of the way: native build (inside the app) and the PWA bundle running */}
      <p className="bg-[#F9F9FF] py-6 text-center text-[10px] leading-none text-gray-300 select-none">
        {appVersionLabel ? `App ${appVersionLabel} · ${getWebBuildLabel()}` : getWebBuildLabel()}
      </p>
    </main>
  );
};

export default ProfileDashboard;
